import { isObject, mapValues } from "radash";

function deepToString<
  Values extends Record<string, unknown> = Record<string, unknown>,
>(values: Values, maxDepth = 5): Values {
  return deepToStringValue(values, maxDepth) as Values;
}

function deepToStringValue(
  values: unknown,
  maxDepth?: number,
  depth = 0,
): unknown {
  if (maxDepth && depth >= maxDepth) {
    return values;
  }

  if (Array.isArray(values)) {
    return values.map((value) => deepToStringValue(value, maxDepth, depth + 1));
  }

  if (isObject(values)) {
    return mapValues(values, (value) => {
      return deepToStringValue(value, maxDepth, depth + 1);
    });
  }

  return String(values);
}

export { deepToString };
